module.exports = __webpack_public_path__ + "img/gebackenegarnelenhintergrund.bb8bb01b.jpg";